module.exports = __webpack_public_path__ + "@/assets/img/042-girl-23.0231a1fc.svg";